import { SET_PORTAL_API } from "./portal_actions";
import { START_LOADING, END_LOADING } from "./loading_actions";
import { LOGOUT } from "./user_actions";
import { RESET_CUSTOMER } from "./customer_actions";
import { RESET_FIRMS } from "./firms_actions";
import { CLEAR_PROFILE_FORM } from "./profile_form_actions";
import { CLEAR_ORDERS } from "./orders_actions";
import {
  TEXT_DELETE_ME_SUCCESS, TITLE_NOTIFICATION, TITLE_ERROR
} from "../../utils/constants";
import { deleteMe } from "../../utils/api";
import { deleteAllCookies } from "../../utils/cookie";
import { getProductsThunk } from "./products_actions";
import { CLEAR_CART } from "./cart_actions";
import { CLEAR_FAV } from "./fav_actions";
import { RESET_FIND_USER_INPUT } from "./find_user_actions";

export const DELETE_ME_EDIT_CP = 'DELETE_ME_EDIT_CP';
export const DELETE_ME_CLEAR_FORM = 'DELETE_ME_CLEAR_FORM';



export const deleteMeThunk = (accessToken, refreshToken,
  navigate, data
) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING });
    deleteMe(accessToken, refreshToken, data)
      .then(data => {
        dispatch({ type: DELETE_ME_CLEAR_FORM });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: TEXT_DELETE_ME_SUCCESS
        });
        navigate('/', { replace: true });
        dispatch({ type: LOGOUT });
        dispatch({ type: CLEAR_ORDERS });
        dispatch({ type: RESET_CUSTOMER });
        dispatch({ type: RESET_FIRMS });
        dispatch(getProductsThunk('', ''));
        dispatch({ type: CLEAR_PROFILE_FORM });
        dispatch({ type: CLEAR_CART });
        dispatch({ type: CLEAR_FAV })
        dispatch({ type: RESET_FIND_USER_INPUT });
        deleteAllCookies();
      })
      .catch(error => {
        console.log('error =', error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}
